import { RegistrationModelSerialStatus } from '../../..';
import { RegistrationModelSerialRequiredType } from './registration-model-serial-required.type';

export interface RegistrationModelSerialCheckResponse {
  status: RegistrationModelSerialStatus;
  required?: RegistrationModelSerialRequiredType[];
}
